import { render, staticRenderFns } from "./XmPaged.vue?vue&type=template&id=59e0478b&scoped=true"
import script from "./XmPaged.vue?vue&type=script&lang=js"
export * from "./XmPaged.vue?vue&type=script&lang=js"
import style0 from "./XmPaged.vue?vue&type=style&index=0&id=59e0478b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0478b",
  null
  
)

export default component.exports